import {
  DatePicker,
  DatePickerProps,
  Modal,
  Select,
  Table,
  Typography,
} from 'antd'
import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Socket } from 'socket.io-client'

import { getErrorMessage, isNotFoundError } from '../../../api/error'
import { useGetListHistory, useGetOneTransaction } from '../../../api/currency'
import { useGetOrderDetailRequestMoney, useGetOrderDetailSendMoney } from '../../../api/send-money'
import { useCancelExchange, useCancelWithdraw } from '../../../api/withdrawal'
import { ReactComponent as CalenderIcon } from '../../../common/images/svg/CalendarIcon.svg'
import { ReactComponent as CheckSelectIcon } from '../../../common/images/svg/CheckSelect.svg'
import { ReactComponent as CloseIcon } from '../../../common/images/svg/CloseIcon.svg'
import { ReactComponent as InforIcon } from '../../../common/images/svg/Infor.svg'
import { ReactComponent as PrinterIcon } from '../../../common/images/svg/Printer.svg'
import { ReactComponent as ArrowIcon } from '../../../common/images/svg/SuffixSelectIcon.svg'
import { ReactComponent as ClearIcon } from '../../../common/images/svg/XCircle.svg'
import { SearchCustom } from '../../../components/inputs/search/searchCustom'
import LoadingOverlay from '../../../components/loading/loadingOverlay'
import ConfirmModal from '../../../components/modal/confirmModal'
import NextPagination from '../../../components/pagination/next'
import PrevPagination from '../../../components/pagination/prev'
import { useNotification } from '../../../components/providers/notification/useNotification'
import StatusTable from '../../../components/status-table/status-table'
import { HistoryOrderType } from '../../../utils/historyOrderType.utils'
import { listStatusSendMoney } from '../../../utils/historyStatus.utils'
import useResponsive from '../../../utils/hooks/useResponsive'
import { formatNumber, padNumber } from '../../../utils/list.utils'
import { Row as RowTable } from '../../components/interface'
import FormCryptoDeposits from './form/form-crypto-deposits'
import FormCryptoWithdrawals from './form/form-crypto-withdrawals'
import FormExchange from './form/form-exchange'
import FormRequestMoney from './form/form-request-money'
import FormSendMoney from './form/form-send-money'

const start = 0
const end = 20

const Fiat = ({
  orderId,
  socket,
  type,
}: {
  orderId: string
  socket: Socket<any, any>
  type: string | null
}) => {
  const navigate = useNavigate()
  const { open: openNotification } = useNotification()
  const { isTablet } = useResponsive()
  const [openModalDeposit, setOpenModalDeposit] = useState<any>(type === 'crypto-deposits' ? orderId : null)
  const [openModalWithdrawal, setOpenModalWithdrawal] = useState<any>(type === 'crypto-withdrawals' ? orderId : null)
  const [openModalRequestMoney, setOpenModalRequestMoney] = useState<any>(type === 'request-money' ? orderId : null)
  const [openModalSendMoney, setOpenModalSendMoney] = useState<any>(type === 'send-money' ? orderId : null)
  const [openModalExchange, setOpenModalExchange] = useState<any>(type === 'exchange' ? orderId : null)
  const [currentPage, setCurrentPage] = useState(1)
  const [deleteDepositId, setDeleteDepositId] = useState<any>(null)
  const [searchStatus, setSearchStatus] = useState<string>('')
  const [searchName, setSearchName] = useState<string>('')
  const [searchDate, setSearchDate] = useState<string>()
  const [cancelWithdrawId, setCancelWithdrawId] = useState<any>(null)
  const [cancelExchangeId, setCancelExchangeId] = useState<any>(null)
  const [params, setParams] = useState({ start, end })

  const {
    data: dataTransaction = {
      data: {
        data: { total: 0, page: 0, pageSize: 0, totalPages: 0, items: [] },
      },
    },
    refetch,
    isLoading,
  } = useGetListHistory({
    ...params,
    name: searchName,
    status: searchStatus,
    _gte: searchDate
      ? moment(searchDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      : undefined,
    _lte: searchDate
      ? moment(searchDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      : undefined,
    _historyType: 'FIAT',
  })

  const {
    data = {
      data: {
        data: {
          id: 0,
          orderId: '',
          decimals: 0,
          status: '',
          amount: '',
          chainType: '',
          symbol: '',
          remitterRegNo: '',
          remitterFullName: 'n',
          remitterCompanyAddress: '',
          remitterCountry: '',
          createdAt: '',
          address: '',
          fees: 0,
          reason: '',
          type: '',
        },
      },
    },
    isFetching: loadingDetail,
    refetch: refetchDetail,
    isRefetching: refetchingDetail,
    isError: isErrorDetail,
    error: errorDetail,
  } = useGetOneTransaction(openModalDeposit)

  const {
    data: dataWithdrawal = {
      data: {
        data: {
          id: 0,
          orderId: '',
          decimals: 0,
          status: '',
          amount: '',
          chainType: '',
          symbol: '',
          beneficiary: '',
          address: '',
          createdAt: '',
          fees: '',
          reason: '',
          type: '',
        },
      },
    },
    isFetching: loadingDetailWithdrawal,
    refetch: refetchDetailWithdrawal,
    isRefetching: refetchingDetailWithdrawal,
    isError: isErrorWithdrawal,
    error: errorWithdrawal,
  } = useGetOneTransaction(openModalWithdrawal)

  const {
    data: dataExchange = {
      data: {
        data: {
          id: 0,
          orderId: '',
          decimals: 0,
          status: '',
          amount: '',
          chainType: '',
          symbol: '',
          beneficiary: '',
          address: '',
          createdAt: '',
          fees: '',
          reason: '',
          type: '',
        },
      },
    },
    isFetching: loadingDetailExchange,
    refetch: refetchDetailExchange,
    isRefetching: refetchingDetailExchange,
    isError: isErrorExchange,
    error: errorExchange,
  } = useGetOneTransaction(openModalExchange)

  const {
    data: dataRequestMoney,
    refetch: refetchDetailRequestMoney,
    isFetching: loadingDetailRequestMoney,
    isRefetching: refetchingDetailRequestMoney,
    isError: isErrorRequestMoney,
    error: errorRequestMoney,
  } = useGetOrderDetailRequestMoney(openModalRequestMoney)

  const {
    data: dataSendMoney,
    refetch: refetchDetailSendMoney,
    isFetching: loadingDetailSendMoney,
    isRefetching: refetchingDetailSendMoney,
    isError: isErrorSendMoney,
    error: errorSendMoney,
  } = useGetOrderDetailSendMoney(openModalSendMoney)

  useEffect(() => {
    if (openModalDeposit && isErrorDetail) {
      if (isNotFoundError(errorDetail)) {
        navigate('/404')
      } else {
        openNotification?.({
          key: 'deposit_detail_error',
          message: getErrorMessage(errorDetail) || 'Failed to load deposit order detail',
          type: 'error',
        })
        setOpenModalDeposit(null)
      }
    }
  }, [openModalDeposit, isErrorDetail, errorDetail, openNotification, navigate])

  useEffect(() => {
    if (
      openModalDeposit &&
      !loadingDetail &&
      !refetchingDetail &&
      !isErrorDetail &&
      (!data?.data?.data || !data?.data?.data?.id)
    ) {
      navigate('/404')
      setOpenModalDeposit(null)
    }
  }, [openModalDeposit, loadingDetail, refetchingDetail, isErrorDetail, data, navigate])

  useEffect(() => {
    if (openModalWithdrawal && isErrorWithdrawal) {
      if (isNotFoundError(errorWithdrawal)) {
        navigate('/404')
      } else {
        openNotification?.({
          key: 'withdrawal_detail_error',
          message: getErrorMessage(errorWithdrawal) || 'Failed to load withdrawal order detail',
          type: 'error',
        })
        setOpenModalWithdrawal(null)
      }
    }
  }, [openModalWithdrawal, isErrorWithdrawal, errorWithdrawal, openNotification, navigate])

  useEffect(() => {
    if (
      openModalWithdrawal &&
      !loadingDetailWithdrawal &&
      !refetchingDetailWithdrawal &&
      !isErrorWithdrawal &&
      (!dataWithdrawal?.data?.data || !dataWithdrawal?.data?.data?.id)
    ) {
      navigate('/404')
      setOpenModalWithdrawal(null)
    }
  }, [
    openModalWithdrawal,
    loadingDetailWithdrawal,
    refetchingDetailWithdrawal,
    isErrorWithdrawal,
    dataWithdrawal,
    navigate,
  ])

  useEffect(() => {
    if (openModalExchange && isErrorExchange) {
      if (isNotFoundError(errorExchange)) {
        navigate('/404')
      } else {
        openNotification?.({
          key: 'exchange_detail_error',
          message: getErrorMessage(errorExchange) || 'Failed to load exchange order detail',
          type: 'error',
        })
        setOpenModalExchange(null)
      }
    }
  }, [openModalExchange, isErrorExchange, errorExchange, openNotification, navigate])

  useEffect(() => {
    if (
      openModalExchange &&
      !loadingDetailExchange &&
      !refetchingDetailExchange &&
      !isErrorExchange &&
      (!dataExchange?.data?.data || !dataExchange?.data?.data?.id)
    ) {
      navigate('/404')
      setOpenModalExchange(null)
    }
  }, [
    openModalExchange,
    loadingDetailExchange,
    refetchingDetailExchange,
    isErrorExchange,
    dataExchange,
    navigate,
  ])

  useEffect(() => {
    if (openModalRequestMoney && isErrorRequestMoney) {
      if (isNotFoundError(errorRequestMoney)) {
        navigate('/404')
      } else {
        openNotification?.({
          key: 'request_money_detail_error',
          message: getErrorMessage(errorRequestMoney) || 'Failed to load request money order detail',
          type: 'error',
        })
        setOpenModalRequestMoney(null)
      }
    }
  }, [openModalRequestMoney, isErrorRequestMoney, errorRequestMoney, openNotification, navigate])

  useEffect(() => {
    if (
      openModalRequestMoney &&
      !loadingDetailRequestMoney &&
      !refetchingDetailRequestMoney &&
      !isErrorRequestMoney &&
      (!dataRequestMoney?.data || !dataRequestMoney?.data?.id)
    ) {
      navigate('/404')
      setOpenModalRequestMoney(null)
    }
  }, [
    openModalRequestMoney,
    loadingDetailRequestMoney,
    refetchingDetailRequestMoney,
    isErrorRequestMoney,
    dataRequestMoney,
    navigate,
  ])

  useEffect(() => {
    if (openModalSendMoney && isErrorSendMoney) {
      if (isNotFoundError(errorSendMoney)) {
        navigate('/404')
      } else {
        openNotification?.({
          key: 'send_money_detail_error',
          message: getErrorMessage(errorSendMoney) || 'Failed to load send money order detail',
          type: 'error',
        })
        setOpenModalSendMoney(null)
      }
    }
  }, [openModalSendMoney, isErrorSendMoney, errorSendMoney, openNotification, navigate])

  useEffect(() => {
    if (
      openModalSendMoney &&
      !loadingDetailSendMoney &&
      !refetchingDetailSendMoney &&
      !isErrorSendMoney &&
      (!dataSendMoney?.data || !dataSendMoney?.data?.id)
    ) {
      navigate('/404')
      setOpenModalSendMoney(null)
    }
  }, [
    openModalSendMoney,
    loadingDetailSendMoney,
    refetchingDetailSendMoney,
    isErrorSendMoney,
    dataSendMoney,
    navigate,
  ])

  const { mutate: cancelWithdraw, isLoading: loadingCancel } =
    useCancelWithdraw({
      onSuccess: (_response: { data: { message: string; data: any } }) => {
        refetch()
        refetchDetailWithdrawal()
        setCancelWithdrawId(null)
        if (openNotification) {
          openNotification({
            key: 'update_success',
            message: 'Withdrawal canceled successfully!',
            type: 'success',
          })
        }
      },
      onError: (error: { message: string; reason_code: string }) => {
        if (openNotification) {
          openNotification({
            key: 'update_failed',
            message: error.message || 'Cancel order failed!',
            type: 'error',
          })
        }
        setCancelWithdrawId(null)
      },
    })

  const { mutate: cancelExchange, isLoading: loadingCancelExchange } =
    useCancelExchange({
      onSuccess: (_response: { data: { message: string; data: any } }) => {
        refetch()
        refetchDetailExchange()
        setCancelExchangeId(null)
        if (openNotification) {
          openNotification({
            key: 'update_success',
            message: 'Exchange order cancelled successfully!',
            type: 'success',
          })
        }
      },
      onError: (error: { message: string; reason_code: string }) => {
        if (openNotification) {
          openNotification({
            key: 'update_failed',
            message: error.message || 'Cancel exchange order failed!',
            type: 'error',
          })
        }
        setCancelExchangeId(null)
      },
    })

  const handleSearchDate: DatePickerProps['onChange'] = (_date, dateString) => {
    setSearchDate(Array.isArray(dateString) ? dateString[0] : dateString)
    setCurrentPage(1)
    setParams({ ...params, start, end })
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setParams({
      start: (page - 1) * dataTransaction?.data?.data?.pageSize || start,
      end: page * dataTransaction?.data?.data?.pageSize || end,
    })
  }

  const handleChangeStatus = (value: string) => {
    setSearchStatus(value)
    setCurrentPage(1)
    setParams({ ...params, start, end })
  }

  const handleSearch = (value: string) => {
    setSearchName(value)
    setCurrentPage(1)
    setParams({ ...params, start, end })
  }

  const handleCancel = () => {
    setOpenModalDeposit(null)
    setOpenModalWithdrawal(null)
    setOpenModalRequestMoney(null)
    setOpenModalSendMoney(null)
    setOpenModalExchange(null)
    refetch()
    navigate('/history?tab=fiat')
  }

  const handleCancelDelete = () => {
    setDeleteDepositId(null)
  }

  const handleSubmitDelete = () => {
    setDeleteDepositId(null)
  }

  const handleOpenModalByOrderType = (record: RowTable) => {
    const orderType = record?.ordertype
    if (orderType === HistoryOrderType.CRYPTO_DEPOSIT) {
      setOpenModalDeposit(record.id)
    } else if (orderType === HistoryOrderType.CRYPTO_WITHDRAWAL) {
      setOpenModalWithdrawal(record.id)
    } else if (orderType === HistoryOrderType.PAYMENT_ORDER) {
      setOpenModalRequestMoney(record.id)
    } else if (orderType === HistoryOrderType.PAYMENT_REQUEST) {
      setOpenModalSendMoney(record.id)
    } else if (orderType === HistoryOrderType.EXCHANGE) {
      setOpenModalExchange(record.id)
    }
  }

  const handleClickOnCell = (record: RowTable) => {
    return {
      onClick: () => {
        handleOpenModalByOrderType(record)
      },
    }
  }

  const checkOrderType = (value: string) => {
    if (value === HistoryOrderType.CRYPTO_WITHDRAWAL) {
      return 'Withdrawal'
    } else if (value === HistoryOrderType.PAYMENT_ORDER) {
      return 'Request Money'
    } else if (value === HistoryOrderType.PAYMENT_REQUEST) {
      return 'Send Money'
    } else if (value === HistoryOrderType.CRYPTO_DEPOSIT) {
      return 'Deposit'
    } else if (value === HistoryOrderType.EXCHANGE) {
      return 'Exchange Money'
    }
    return '-'
  }

  const columns = useMemo((): ColumnType<RowTable>[] => {
    const columns: ColumnType<RowTable>[] = [
      {
        dataIndex: 'id',
        title: <span className={'column-header'}>ORDER</span>,
        onCell: handleClickOnCell,
        width: '14%',
        render: (_value: string, record: RowTable) => (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography className='text-id'>{record?.orderId}</Typography>
            <Typography className='text-table text-time'>
              {moment(record?.createdAt || 0).format('HH:mm:ss DD/MM/YYYY')}
            </Typography>
          </div>
        ),
      },
      {
        dataIndex: 'ordertype',
        title: <span className={'column-header'}>ORDER TYPE</span>,
        onCell: handleClickOnCell,
        width: '21.2%',
        render: (value: string) => (
          <Typography className='text-table'>{checkOrderType(value)}</Typography>
        ),
      },
      {
        dataIndex: 'currency',
        title: <span className={'column-header'}>CURRENCY</span>,
        onCell: handleClickOnCell,
        width: '16%',
        render: (value: string) => (
          <Typography className='text-table-bold' style={{ color: 'white' }}>
            {value}
          </Typography>
        ),
      },
      {
        dataIndex: 'amount',
        title: <span className={'column-header'}>AMOUNT</span>,
        onCell: handleClickOnCell,
        width: '18.2%',
        render: (value: string, record: RowTable) => (
          <Typography className='text-table text-table-bold'>
            {formatNumber(Number(value), record?.decimals || 4, true)}
          </Typography>
        ),
      },
      {
        dataIndex: 'status',
        onCell: handleClickOnCell,
        width: '18.2%',
        title: <span className={'column-header'}>STATUS</span>,
        render: (value: string) => <StatusTable status={value} />,
      },
      {
        title: <div></div>,
        render: (record: RowTable) => (
          <div className='action-table'>
            <InforIcon
              className='icon-animation'
              style={{ cursor: 'pointer' }}
              onClick={() => handleOpenModalByOrderType(record)}
            />
          </div>
        ),
      },
    ]
    return columns.filter(({ key }) => !key)
  }, [])

  useEffect(() => {
    if (!orderId) return
    if (type === HistoryOrderType.CRYPTO_DEPOSIT) {
      setOpenModalDeposit(orderId)
    } else if (type === HistoryOrderType.CRYPTO_WITHDRAWAL) {
      setOpenModalWithdrawal(orderId)
    } else if (type === HistoryOrderType.PAYMENT_REQUEST) {
      setOpenModalRequestMoney(orderId)
    } else if (type === HistoryOrderType.PAYMENT_ORDER) {
      setOpenModalSendMoney(orderId)
    } else if (type === HistoryOrderType.EXCHANGE) {
      setOpenModalExchange(orderId)
    }
  }, [orderId])

  useEffect(() => {
    const handleWalletUpdated = () => {
      refetch()
    }
    socket.on(`user.wallet.updated`, handleWalletUpdated)
    return () => {
      socket.off(`user.wallet.updated`, handleWalletUpdated)
    }
  }, [socket, refetch])

  const handleCancelWithdrawal = (id: any) => {
    setCancelWithdrawId(id)
  }

  const handleCancelDeleteWithdrawal = () => {
    if (loadingCancel) return
    setCancelWithdrawId(null)
  }

  const handleSubmitDeleteWithdrawal = () => {
    cancelWithdraw(cancelWithdrawId)
  }

  const handleCancelExchange = (id: any) => {
    setCancelExchangeId(id)
  }

  const handleCancelDeleteExchange = () => {
    if (loadingCancelExchange) return
    setCancelExchangeId(null)
  }

  const handleSubmitDeleteExchange = () => {
    cancelExchange({
      orderId: cancelExchangeId,
      status: 'CANCELLED',
    })
  }

  return (
    <>
      <div className={'frame-history-right-header'}>
        <SearchCustom
          value={searchName}
          placeholder='Search'
          onChange={handleSearch}
          onSubmit={handleSearch}
        />
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <Select
            clearIcon={<ClearIcon style={{ height: 12, width: 12 }} />}
            style={{ width: '150px' }}
            placeholder='All Status'
            suffixIcon={searchStatus ? null : <ArrowIcon />}
            onChange={handleChangeStatus}
            allowClear
            optionLabelProp='label'>
            {listStatusSendMoney.map((item: any) => (
              <Select.Option
                key={item?.value}
                value={item?.value}
                label={item.label}>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: 2,
                  }}>
                  <span
                    className='ant-select-custom-value '
                    style={{ whiteSpace: 'nowrap' }}>
                    {item?.label}
                  </span>
                  {searchStatus === item?.value && (
                    <CheckSelectIcon style={{ flexShrink: 0 }} />
                  )}
                </span>
              </Select.Option>
            ))}
          </Select>
          <DatePicker
            value={searchDate ? dayjs(searchDate, 'DD/MM/YYYY') : undefined}
            placeholder='All Date'
            className='custom-input-date'
            format={'DD/MM/YYYY'}
            style={{ width: '150px' }}
            onChange={handleSearchDate}
            clearIcon={<ClearIcon style={{ height: 12, width: 12 }} />}
            suffixIcon={searchDate ? null : <CalenderIcon />}
            allowClear
          />
        </div>
      </div>
      <Table
        className={`custom-ant-table history-ant-table ${isLoading ? 'table-hidden-empty' : ''}`}
        rowKey={(record: any) => `${record?.id}-${record?.orderId}-${record?.orderType}`}
        rowClassName={() => 'custom-table-row'}
        style={{ tableLayout: 'auto' }}
        columns={columns as any}
        dataSource={dataTransaction?.data?.data?.items}
        loading={isLoading}
        scroll={{ y: 'calc(100vh - 323px)' }}
        pagination={{
          current: currentPage,
          total: dataTransaction?.data?.data?.total,
          pageSize: dataTransaction?.data?.data?.pageSize,
          onChange: handlePageChange,
          itemRender: (page, type, element) => {
            switch (type) {
              case 'prev':
                return (
                  <PrevPagination
                    currentPage={currentPage}
                    setCurrentPage={(page) => handlePageChange(page)}
                  />
                )
              case 'next':
                return (
                  <NextPagination
                    totalPage={dataTransaction.data.data.totalPages}
                    currentPage={currentPage}
                    setCurrentPage={(page) => handlePageChange(page)}
                  />
                )
            }
            return element
          },
        }}
      />
      <Modal
        open={refetchingDetail ? !!openModalDeposit : !!openModalDeposit && !loadingDetail}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{
                fontSize: isTablet ? 16 : 20,
                fontWeight: 700,
                color: '#C2C6CE',
              }}>
              {`Deposit ${data?.data?.data?.orderId ?? padNumber(orderId || openModalDeposit)}`}
            </Typography>
            <CloseIcon
              className='icon-animation'
              onClick={handleCancel}
              style={{ cursor: 'pointer' }}
            />
          </>
        }
        className='send-money-modal'>
        <FormCryptoDeposits
          orderId={orderId || openModalDeposit}
          socket={socket}
          data={data}
          isLoading={loadingDetail}
          refetch={refetchDetail}
        />
      </Modal>

      <Modal
        open={refetchingDetailWithdrawal ? !!openModalWithdrawal : !!openModalWithdrawal && !loadingDetailWithdrawal}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{ fontSize: 20, fontWeight: 700, color: '#C2C6CE' }}>
              {`Withdraw ${dataWithdrawal?.data?.data?.orderId ?? padNumber(orderId || openModalWithdrawal)}`}
            </Typography>
            <CloseIcon
              className='icon-animation'
              onClick={handleCancel}
              style={{ cursor: 'pointer' }}
            />
          </>
        }
        className='send-money-modal'>
        <FormCryptoWithdrawals
          orderId={orderId || openModalWithdrawal}
          socket={socket}
          handleCancelOrder={handleCancelWithdrawal}
          data={dataWithdrawal}
          isLoading={loadingDetailWithdrawal}
          refetch={refetchDetailWithdrawal}
        />
      </Modal>

      <Modal
        open={refetchingDetailSendMoney ? !!openModalSendMoney : !!openModalSendMoney && !loadingDetailSendMoney}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <Typography
                style={{ fontSize: 20, fontWeight: 700, color: '#C2C6CE' }}>
                {`Send Money ${dataSendMoney?.data?.orderId ?? padNumber(orderId || openModalSendMoney)}`}
              </Typography>
              <PrinterIcon
                className='icon-animation'
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  window.open(dataSendMoney?.data?.printableFormUrl, '_blank')
                }
              />
            </div>
            <CloseIcon
              className='icon-animation'
              onClick={handleCancel}
              style={{ cursor: 'pointer' }}
            />
          </>
        }
        className='send-money-modal'>
        <FormSendMoney
          orderId={orderId || openModalSendMoney}
          refetch={refetch}
          socket={socket}
          data={dataSendMoney}
          refetchDetail={refetchDetailSendMoney}
        />
      </Modal>

      <Modal
        open={refetchingDetailRequestMoney ? !!openModalRequestMoney : !!openModalRequestMoney && !loadingDetailRequestMoney}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <Typography
                style={{ fontSize: 20, fontWeight: 700, color: '#C2C6CE' }}>
                {`Request Money ${dataRequestMoney?.data?.orderId ?? padNumber(orderId || openModalRequestMoney)}`}
              </Typography>
              <PrinterIcon
                className='icon-animation'
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  window.open(dataRequestMoney?.data?.printableFormUrl, '_blank')
                }
              />
            </div>
            <CloseIcon
              className='icon-animation'
              onClick={handleCancel}
              style={{ cursor: 'pointer' }}
            />
          </>
        }
        className='send-money-modal'>
        <FormRequestMoney
          orderId={orderId || openModalRequestMoney}
          refetch={refetch}
          socket={socket}
          data={dataRequestMoney}
          refetchDetail={refetchDetailRequestMoney}
        />
      </Modal>

      <ConfirmModal
        type='warning'
        title='Cancel Withdrawal?'
        description='Are you sure you want to cancel this withdrawal order? This action cannot be undone.'
        open={!!cancelWithdrawId}
        onCancel={handleCancelDeleteWithdrawal}
        onSubmit={handleSubmitDeleteWithdrawal}
        isLoading={loadingCancel}
      />

      <Modal
        open={refetchingDetailExchange ? !!openModalExchange : !!openModalExchange && !loadingDetailExchange}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        maskClosable={false}
        title={
          <>
            <Typography
              style={{ fontSize: 20, fontWeight: 700, color: '#C2C6CE' }}>
              {`Exchange Money ${dataExchange?.data?.data?.orderId ?? padNumber(orderId || openModalExchange)}`}
            </Typography>
            <CloseIcon
              className='icon-animation'
              onClick={handleCancel}
              style={{ cursor: 'pointer' }}
            />
          </>
        }
        className='send-money-modal'>
        <FormExchange
          orderId={orderId || openModalExchange}
          socket={socket}
          handleCancelExchange={handleCancelExchange}
          data={dataExchange}
          isLoading={loadingDetailExchange}
          refetch={refetchDetailExchange}
        />
      </Modal>

      <ConfirmModal
        type='warning'
        title='Cancel Exchange Money?'
        description='Are you sure you want to cancel this exchange order? This action cannot be undone.'
        open={!!cancelExchangeId}
        onCancel={handleCancelDeleteExchange}
        onSubmit={handleSubmitDeleteExchange}
        isLoading={loadingCancelExchange}
      />

      <ConfirmModal
        type='warning'
        title='Confirm Delete'
        description='Do you want to delete this record?'
        open={!!deleteDepositId}
        onCancel={handleCancelDelete}
        onSubmit={handleSubmitDelete}
        isLoading={false}
      />
      <LoadingOverlay loading={loadingDetail && !refetchingDetail} time={0} />
    </>
  )
}

export default Fiat
